// extracted by mini-css-extract-plugin
export default {"SponsorBox":"Sponsors_SponsorBox__1ECV1"};